(($) => {
  Drupal.behaviors.requestformfileupload = {

    attach: function(context, settings) {
      this.init(context, settings);
    },

    init: function(context, settings) {

      $(document).find('.form-item-travel-program .form-file').once().each(function(index, element) {
        const $fileUpload = $(element);
        if(!$fileUpload.hasClass('styled-file-upload')) {

          // add an extra class to the file upload input:
          $fileUpload.addClass('styled-file-upload__item');

          // put a wrapper around the file-upload:
          const $wrapper = $('<div class="styled-file-upload"></div>');
          $fileUpload.wrap($wrapper);

          // put a label-wrapper around the file-upload,
          // -> the user will click on this:
          const $labelwrapper = $('<label class="styled-file-upload__label"></label>');
          $fileUpload.wrap($labelwrapper);

          // add a "visual" label/button:
          $fileUpload.after(`<div class="styled-file-upload__visual">
            <div class="styled-file-upload__visual-inner">
              <div class="styled-file-upload__visual-line-label">${ Drupal.t('Add your file here') }</div>
              <div class="styled-file-upload__visual-line-action">${ Drupal.t('Browse for your file') }</div>
            </div>
          </div>`);

        }
      });
    }

  };
})(jQuery);
